export default __webpack_public_path__ + "static/media/VelionioParuosimas.9650611f.svg";